import loadable from '@loadable/component';

export const ExpiredJobPageLoadable = loadable(
  () => import('./ExpiredJobPage'),
  {
    resolveComponent: (module) => module.ExpiredJobPage,
  },
);
